export default __webpack_public_path__ + "static/media/it_icon.3778e632.svg";